/**
 * Filter to display 'K' for Kindergarten
 */
angular.module('rightPaneModule')
.filter('GradeCompactDisplayFilter', [function() {
    return function(gradeName) {
        if (gradeName === 'Kindergarten') {
            return 'K';
        } else {
            return gradeName;
        }
    };
}]);
